import { actionCopyFr } from "./actionCopy";
import { listCopyFr } from "./listCopy";

export const templatesCopyFr = {
    templates: "Modèles",
    navDescription: "Parcourez les modèles et invitez des patients à suivre leurs résultats.",
    myTemplatesTitle: "Mes modèles",
    myTemplatesDescription:
        "Créez et gérez des modèles pour inviter rapidement des patients à suivre leurs résultats. Cliquez sur une ligne pour utiliser un modèle, ou ouvrez le menu pour plus d'actions.",
    myTemplatesAria: "Mes modèles",
    publicTemplatesTitle: "Modèles publics",
    breadcrumbNew: "Nouveau",
    selectAtLeastOneTemplate: "Sélectionnez au moins un modèle",
    addTemplatesToAccount: (count) =>
        count === 1 ? "Ajouter le modèle à mon compte" : `Ajouter ${count} modèles à mon compte`,
    creatingTemplates: "Création des modèles…",
    publicTemplatesDescription:
        "Parcourez des configurations prêtes à l'emploi et ajoutez-les à votre compte, ou créez les vôtres. Sélectionnez un modèle pour démarrer rapidement.",
    browsePublic: "Parcourir les modèles publics",
    browsePublicAria: "Parcourir les modèles publics",
    newTemplate: "Nouveau modèle",
    newTemplateAria: "Nouveau modèle",
    makeMyOwn: "Créer le mien",
    favourites: "Favoris",
    noQuestionnaires: "Aucun questionnaire",
    moreQuestionnaires: (count) => `+${count} autres`,
    useTemplate: "Utiliser le modèle",
    newDiary: "Nouveau journal",
    searchPlaceholder: "Rechercher des modèles...",
    searchAria: "Rechercher des modèles",
    clearSearchAria: actionCopyFr.clearSearch,
    filters: actionCopyFr.filters,
    clearAll: actionCopyFr.clearAll,
    procedureFilterPrefix: "Intervention :",
    statusFilterPrefix: "Statut :",
    substanceFilterPrefix: "Substance :",
    subsiteFilterPrefix: "Sous-site :",
    siteFilterPrefix: "Site :",
    typeFilterPrefix: "Type :",
    areaFilterPrefix: "Zone :",
    consultationFilterPrefix: "Consultation :",
    removeProcedureFilterAria: (label) => `Supprimer le filtre d'intervention ${label}`,
    removeStatusFilterAria: (label) => `Supprimer le filtre de statut ${label}`,
    removeOwnerFilterAria: (name) => `Supprimer le filtre de propriétaire ${name}`,
    removePeopleFilterAria: (name) => `Supprimer le filtre de personnes ${name}`,
    removeSubstanceFilterAria: "Supprimer le filtre de substance",
    removeSubsiteFilterAria: "Supprimer le filtre de sous-site",
    removeSiteFilterAria: "Supprimer le filtre de site",
    removeShockwaveTypeFilterAria: "Supprimer le filtre de type d'ondes de choc",
    removeAreaFilterAria: "Supprimer le filtre de zone",
    removeConsultationFilterAria: "Supprimer le filtre de consultation",
    ownerFilterLabel: "Propriétaire (clinicien ou secrétaire)",
    ownerFilterPlaceholder: "Tous les utilisateurs",
    statusFilterLabel: "Statut",
    statusFilterPlaceholder: "Tous les statuts",
    peopleOnTemplateLabel: "Personnes sur le modèle",
    peopleOnTemplatePlaceholder: "Toute personne sur le modèle",
    procedureTypeLabel: "Type d'intervention",
    procedureTypePlaceholder: "Tout type d'intervention",
    areaLabel: "Zone",
    substanceLabel: "Substance",
    subsiteLabel: "Sous-site",
    typeLabel: "Type",
    siteLabel: "Site",
    consultationLabel: "Consultation",
    selectPlaceholder: "Sélectionner...",
    clearFilterAria: (label) => `Effacer ${label}`,
    injection: "Injection",
    shockwave: "Ondes de choc",
    surgery: "Chirurgie",
    consultation: "Consultation",
    medication: "Médicament",
    product: "Produit",
    published: listCopyFr.published,
    draft: listCopyFr.draft,
    noTemplatesYet: "Aucun modèle pour le moment",
    noMatchingTemplates: "Aucun modèle correspondant",
    noTemplatesYetHint: "Créez votre premier modèle pour inviter rapidement des patients.",
    noMatchingHint: "Essayez de modifier votre recherche ou vos filtres.",
    createFirstTemplate: "Créer votre premier modèle",
    emptyTemplatesHelpLink: "Comment créer un modèle ?",
    tableHint:
        "Cliquez sur une ligne pour inviter un patient à partir de ce modèle. Utilisez « Nouveau journal » et la modification sur chaque ligne, ou ouvrez le menu pour les favoris et d'autres actions.",
    forms: "Formulaires",
    lastEdited: "Dernière modification",
    procedure: "Intervention",
    area: "Zone",
    people: "Personnes",
    details: "Détails",
    actions: listCopyFr.actions,
    select: "Sélectionner",
    useTemplateAria: "Nouveau journal",
    editTemplateAria: "Modifier le modèle",
    tapToUseTemplate: "Appuyez pour utiliser ce modèle",
    useThisTemplateAria: "Utiliser ce modèle",
    clickRowToUseAria: "Cliquez sur la ligne pour utiliser ce modèle",
    publicTemplatesTableAria: "Modèles publics",
    yourTemplatesTableAria:
        "Vos modèles ; choisissez une ligne pour utiliser ce modèle, ou utilisez les actions de chaque ligne",
    noTemplatesInView: "Aucun modèle dans cette vue.",
    showingTemplatesRange: (start, end, total) => `Modèles ${start} à ${end} sur ${total}`,
    previous: actionCopyFr.previous,
    next: actionCopyFr.next,
    save: actionCopyFr.save,
    rename: actionCopyFr.rename,
    editTemplate: "Modifier le modèle",
    addToFavourites: "Ajouter aux favoris",
    removeFromFavourites: "Retirer des favoris",
    copyUrl: "Copier l'URL",
    shareTemplate: "Partager le modèle",
    labelsAndDiaryType: "Étiquettes et type de journal",
    publishTemplate: "Publier le modèle",
    linkToMasterTemplate: "Lier au modèle principal",
    duplicate: actionCopyFr.duplicate,
    delete: actionCopyFr.delete,
    deleteTemplateTitle: "Supprimer le modèle",
    deleteTemplateDescription: "Voulez-vous vraiment supprimer ce modèle ? Cette action est irréversible.",
    cancel: actionCopyFr.cancel,
    templateUpdatedToast: "Modèle mis à jour avec succès",
    copiedToClipboardToast: "Copié dans le presse-papiers",
    unnamedTemplate: "Modèle sans nom",
    questionnaireSchedule: "Calendrier du questionnaire",
    interventionStep: "Intervention",
    injectionDetails: "Informations sur l'injection",
    surgeryClinicians: "Cliniciens de l'opération",
    surgeryDetails: "Informations sur l'opération",
    shockwaveClinicians: "Cliniciens des ondes de choc",
    shockwaveDetails: "Informations sur les ondes de choc",
    noIntervention: "Aucune intervention",
    dateStep: "Date",
    dateQuestion: "À partir de quelle date les suivis sont-ils comptés ?",
    dateDiaryStart: "À partir du jour de création du journal",
    dateDiaryStartHint: "Les questionnaires commencent tout de suite. Aucune date n'est demandée au patient.",
    dateAskPatient: "Laisser vide - le patient nous l'indique",
    dateAskPatientHint:
        "Le patient indique la date lors de la configuration de son journal. Vous pouvez aussi l'ajouter plus tard.",
    saveTemplate: "Enregistrer le modèle",
    lockLabel: "Verrouiller",
    unlockLabel: "Déverrouiller",
    lockedLabel: "Verrouillé",
    lockScope: {
        trackers: "Questionnaires",
        "tracker.schedule": "Calendriers",
        consents: "Consentements",
        event: "Intervention",
        "person.injectingClinicianId": "Clinicien réalisant l'injection",
        "person.referringClinicianId": "Médecin adresseur",
        "person.operatingClinicianId": "Clinicien opérateur",
        "person.productId": "Produit",
    },
    lockedByTemplateCreator: "Verrouillé par le créateur du modèle",
    usageInstructionsPlaceholder: "p. ex. À porter 2 heures par jour, nettoyer après chaque utilisation",
    productNameRequired: "Le nom du produit est obligatoire",
    contactEmail: "E-mail de contact",
    selectContactPlaceholder: "Sélectionner un e-mail de contact",
    defaultContactForOrganisation: (organisationNames) => `Par défaut pour ${organisationNames}`,
    templateCreatedTitle: "Modèle créé avec succès !",
    templateCreatedMessage: "Le temps gagné est du temps gagné !",
    templateNotFoundTitle: "Modèle introuvable",
    templateNotFoundDescription: "Impossible de trouver le modèle. Veuillez réessayer.",
    backToTemplates: "Retour aux modèles",
    userFallback: (idPrefix) => `Utilisateur ${idPrefix}...`,
    eventTypeLabel: (type: string) => {
        const map: Record<string, string> = {
            injection: "Injection",
            shockwave: "Ondes de choc",
            surgery: "Chirurgie",
            education: "Consultation",
            medication: "Médicament",
            product: "Produit",
        };
        return map[type] ?? type;
    },
    statusLabel: (status) => (status === "published" ? "Publié" : "Brouillon"),
};
